export default class ServiceCategory {
  static getAddedCategory (prevCategories, newCategories) {
    const prevCategoriesIds = new Set (prevCategories.map (category => category.id))

    return newCategories
      .filter (category => !prevCategoriesIds.has (category.value.id))
      .map (category => ({...category.value}))
  }
}
